import React from 'react'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { useHistory, useLocation, useParams } from 'react-router'
import { IncreaseOriginalValueDetailContent } from './IncreaseOriginalValueDetailContent'

export const IncreaseOriginalValueDetail = (props: any) => {
  const history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location = useLocation()
  const editData = location?.state as any

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/increase-original-value`
          )
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Increase in Original Value', current: true },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="xsTitle flex-space">
            <span style={{ fontWeight: 'bold' }}>{editData?.Asset?.name}</span>
          </span>
        }
        rightText={<span className="xsTitle">{editData?.DocNo}</span>}
        infoLine={
          <>
            <div className="desc flex-space">
              {formatDate(editData?.change_date)}
            </div>
          </>
        }
        rightInfoLine={
          <span className="desc">
            {`${amtStr(editData?.old_original_value)}`}
            <span> → </span>
            <span style={{ color: 'orange' }}>
              {amtStr(editData?.new_original_value)}
            </span>
          </span>
        }
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <IncreaseOriginalValueDetailContent
            listEl={editData}
            listStatus={editData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
